import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeBody extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeBody {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeBody(value);
  }
}
